
const Header = ({ home, away, title }) => {
    return (
      <div className="flex flex-col mt-6">
        <div className="flex font-semi-bold">
          <div className="flex-1 bg-custom-gradient-compare-strength pl-4 pr-[23px] pt-[5px] rounded-tl-[4px] rounded-tr-[4px] text-white text-sm">
            {home?.name}
          </div>
          <div className="flex-1 text-center font-semi-bold text-black dark:text-stroke-o3 text-sm">
            {title}
          </div>
          <div className="flex-1 bg-custom-gradient-compare-strength-away text-right pl-[7px] pr-4 pt-[5px] text-button-blue-bet text-sm">
            {away?.name}
          </div>
        </div>
        <div className="flex">
          <div
            className="flex flex-col text-center h-[7px] bg-button-blue-bet"
            style={{ width: "51%" }}
          ></div>
          <div
            className="text-center h-[7px] bg-golden-yellow"
            style={{ width: "49%" }}
          ></div>
        </div>
      </div>
  );
};

export default Header;
